import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const PostCampaign = {
  Helmet: lazy(() => import('./components/PostCampaignHelmet.tsx')),
  CampaignsList: lazyNamed(() => import('./scenes/CampaignsList/index.tsx'), 'CampaignsList'),
  Overview: lazy(() => import('./scenes/Overview/index.tsx')),
  Edit: lazy(() => import('./scenes/BookingTool/containers/PostCampaignEdit/index.tsx')),
  Information: lazy(() => import('./scenes/BookingTool/containers/PostCampaignInformation/index.tsx')),
  TargetGroupSettings: lazy(() => import('./scenes/BookingTool/containers/PostCampaignTargetGroupSettings/index.tsx')),
  Calculation: lazyNamed(
    () => import('./scenes/BookingTool/containers/PostCampaignCalculation/index.tsx'),
    'PostCampaignCalculationRenderer',
  ),
  EditPositions: lazy(() => import('./scenes/BookingTool/containers/PostCampaignPositionsEdit/index.tsx')),
  DocumentPreview: lazy(() => import('./scenes/BookingTool/containers/PostCampaignPreview/index.tsx')),
  BookingToolProviders: lazy(() => import('src/modules/PostCampaign/providers/PostBookingToolProviders.tsx')),
  ListAndOverviewProviders: lazy(() => import('src/modules/PostCampaign/providers/ListAndOverviewProviders.tsx')),
  Providers: lazyNamed(() => import('src/modules/PostCampaign/providers/PostCampaignProviders.tsx'), 'PostCampaignProviders'),
  History: lazyNamed(() => import('./scenes/History/index.tsx'), 'History'),
};

export default PostCampaign;
